<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="transaction_completion_tooltip_name" :name="transaction_completion_tooltip_name" :description="transaction_completion_tooltip_description" :editable="editable"></tool-tip>
    <div style="padding-right: 0px !important; padding-left: 0px !important" class="col-sm-6">
        <el-alert
          v-if="isMonetaryTransaction && !isPartnerAccount"
          type="warning"
          :closable="false"
          title="Important Information"
          :description=disbursementTextInfo
          show-icon
          effect="dark"
        >
        </el-alert>
      </div>
      <br/>
    <div class="row">
      <div>
        <transaction-completion-modal
        v-if="isMonetaryTransaction || (isPartial &&  isRikOrEveOrder) && !isOUSD"
          :is-read-only="isReadOnly || isViewOnly"
          :isOpen="
            showTransactionCompletionModal && isNew"
            :key="refreshKey"
          :id="disbursingCollectionId"
          :is-new="isNew"
          :is-completion="true"
          v-on:modal-closed="clearModalData"
          style="margin-right:2px"
        >
          <template v-slot:modal-link :disabled="deleteDisabled">
            {{ 'Completion Document'}}
          </template>
        </transaction-completion-modal>
        <AlertSignature v-if="isRikOrEveOrder && !isPartial  && !isOUSD" ref="" :headerText="'Transaction Completion Upload'"
          :module="'transactionComplete'" :action="''"
          activeTab="UPLOAD" :signatureData="{}"
          v-on:onUpload="fileUploaded"
          :fileTypeId="transactionDocumentId" 
          :textDisabled="true"
          :isPinVerified="true"
          :drawDisabled="true"
          :uploadDisabled="isPartnerAccount || transactionCompletedDocumentStatus"
          :certificateDisabled="true"
          :disabled="isViewOnly" />
          <br/>
          <span v-show=" isRikOrEveOrder && !isPartial && transactionCompletedDocumentStatus" class="error">
              Transaction completion document is already uploaded. You must delete the transaction completion entry in the documents tab to upload a new document.  </span>
            </div>
        <div         v-if="isMonetaryTransaction || (isPartial &&  isRikOrEveOrder)  && !isOUSD"
        style="margin: 10px;">
          <p style="font-weight: 500;color:green">
          OR
        </p>
        </div>
        <div>
        <transaction-completion-modal
        v-if="isMonetaryTransaction || (isPartial &&  isRikOrEveOrder)  && !isOUSD"

          :is-read-only="isReadOnly || isViewOnly"
          :isOpen="
            showTransactionCompletionModal"
          :id="disbursingCollectionId"
          :is-new="isNew"
          :is-transaction-edit="isTransactionEdit"
          :key="refreshKey"

          :prev-amount="prevAmount"
          v-on:modal-closed="clearModalData"
          style="margin-right:2px"
        >
          <template v-slot:modal-link :disabled="deleteDisabled">
          {{ isUsBuyOrder ? 'Add Disbursement' : 'Add Collection'}}
          </template>
        </transaction-completion-modal>
      </div>
    </div>
     <div class="row" v-if="isMonetaryTransaction">
      <div class="col-sm-12">
        <el-table
          :data="disbursingCollections"
          :default-sort="{
            prop: isUsBuyOrder ? 'tracerDate' : 'voucherDate',
            order: 'ascending',
          }"
        >
          <el-table-column label="Operations" min-width="120" v-if="!isPartnerAccount">
            <template slot-scope="{ row, index }">
              <el-tooltip
                class="item"
                v-show="!row.editMode"
                effect="dark"
                content="Delete"
                placement="top-start"
              >
                <a
                  @click.prevent
                  v-if="isReadOnly"
                  href="#"
                  class="btn-link btn-danger btn-disabled"
                  :disabled="deleteDisabled"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                </a>
                <a
                  v-else
                  href="##"
                  @click.prevent="handleDelete(row, index)"
                  class="btn-link btn-danger"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                </a>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="Edit"
                placement="top-start"
              >
                <base-button
                  v-show="!isReadOnly"
                  :disabled="isReadOnly"
                  class="btn btn-icon btn-fab btn-default btn-sm btn-link"
                  @click.native="viewItem(row.id, index, getDocumentType(row), row.amountPaid)"
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
            prop="name"
            label="Fund Citation Name"
            sortable
          >
          </el-table-column>
          <el-table-column
            min-width="200"
            prop="fileId"
            label="Category"
            sortable
          >
          <template slot-scope="{ row, index }">

         {{ getDocumentType(row) }}
          </template>
          </el-table-column>
          <el-table-column
            min-width="195"
            prop="abbreviation"
            label="Fund Citation Abbr"
            sortable
          >
          </el-table-column>
          <el-table-column
            min-width="240"
            prop="totalAmount"
            label="Total Cost Per Fund Cite"
            :formatter="formatCurrency"
            sortable
          >
          </el-table-column>
          <el-table-column
            v-if="!isUsBuyOrder"
            min-width="190"
            prop="amountPaid"
            label="Amount Collected"
            :formatter="formatCurrency"
            sortable
          >
          </el-table-column>
          <el-table-column
            v-else
            min-width="190"
            prop="amountPaid"
            label="Amount Paid"
            :formatter="formatCurrency"
            sortable
          >
          </el-table-column>
          <el-table-column
            min-width="190"
            prop="voucher"
            label="Voucher #"
            sortable
          >
          </el-table-column>
          <el-table-column
            min-width="190"
            prop="tracer"
            label="Tracer #"
            sortable
          >
          </el-table-column>
          <el-table-column
          
            min-width="195"
            prop="voucherDate"
            label="Voucher Date"
            :formatter="formatDate"
            sortable
          >
          </el-table-column>
          <el-table-column
           
            min-width="195"
            prop="tracerDate"
            label="Tracer Date"
            :formatter="formatDate"
            sortable
          >
          </el-table-column>
          <el-table-column
            min-width="220"
            prop="outstandingBalance"
            label="Outstanding Balance"
            :formatter="formatCurrency"
            sortable
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row more-top-padding" v-if="isMonetaryTransaction">
      <div class="col-sm-4 offset-sm-2">
        <label for="totalOutstandingBalance">Total Outstanding Balance</label>
        <base-input
          id="totalOutstandingBalance"
          type="text"
          disabled
          v-model="disbursingCollectionOutstandingBalance"
          name="totalOutstandingBalance"
          data-vv-as="Total Outstanding Balance"
        />
      </div>
      <div class="col-sm-4">
        <label>Outstanding Balance Date</label>
        <el-date-picker
          v-model="outstandingBalanceDate"
          disabled
          type="date"
          format="dd-MMMM-yyyy"
          placeholder="Outstanding Balance Date"
        >
        </el-date-picker>
      </div>
    </div>

    <div v-if="isMonetaryTransaction && !isPartnerAccount" class="row justify-content-center"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  Divider,
  Alert,
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
} from "element-ui";
import Utility from "@/mixins/utility/utility";
import Util from "@/util/util";
import { EditableCell } from "@/components";
import DisbursingCollectionInformationModal from "./DisbursingCollectionInformationModal.vue";
import TransactionCompletionModal from "./TransactionCompleteModal.vue";
import swal from "sweetalert2";
import  toolTip  from "../../../Tooltip";
import AlertSignature from "@/components/App/signatures/AlertSignature.vue";


export default {
  props: ["isReadOnly"],
  name: "DisbursingCollectionInformation",
  mixins: [Utility],
  components: {
    [Divider.name]: Divider,
    [Alert.name]: Alert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button,
    EditableCell,
    DisbursingCollectionInformationModal,
    TransactionCompletionModal,
    toolTip,
    AlertSignature
  },
  async mounted() {
    await this.getAllTooltips()
    await this.getInspectedReceivedBy(this.$route.params.id);
    await this.getDocumentTypes()
    const transactionDoc = this.documentTypes.find((e)=> e.name === "TRANSACTION COMPLETION");
    if (transactionDoc) {
      this.transactionDocumentId = transactionDoc.id;
    }

   this.loadToolTips()
  },
  data() {
    return {
      showDisbursingCollectionInformationModal: false,
      showTransactionCompletionModal: false,
      disbursingCollectionId: 0,
      disbursingCollectionInfoId: 0,
      deleteDisabled: false,
      isNew: true,
      editing: null,
      isEditing: false,
      editingRowId: null,
      orderTotal: "",
      amountCollected: "",
      transaction_completion_tooltip_description: '',
      transaction_completion_tooltip_name: '',
      disbursementTextInfo:
      'Add payments / collection to reach a zero balance or upload a completion document to complete the module.',
      transactionDocumentId : null,
      isTransactionEdit: false,
      prevAmount: 0,
      refreshKey: 0,

    };
  },
  computed: {
    ...mapGetters({
      disbursingCollectionInfo:
        "disbursingCollectionInformation/disbursingCollectionInfo",
      disbursingCollectionInfoErrors:
        "disbursingCollectionInformation/disbursingCollectionInfoErrors",
        isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
        preOrder: "preOrderDetail/preOrder",
      isUsBuyOrder: "preOrderDetail/isUsBuyOrder",
      isMonetaryTransaction: "preOrderDetail/isMonetaryOrder",
      documents: "documents/getDocuments",
      fundCitations: "fundCitation/fundCitations",
      disbursingCollections:
        "disbursingCollectionInformation/disbursingCollections",
      disbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/disbursingCollectionOutstandingBalance",
      isPartnerAccount: "authentication/isPartnerAccount",
      isOUSD: "authentication/isOUSD",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",
      inspectedReceivedBy: "inspectedReceivedBy/inspectedReceivedBy",
      documentTypes: "documents/documentTypes",


    }),
    isViewOnly(){
         
      return window.location.href.includes(`/view/`);
  
    },
    balanceDue() {
      if (this.disbursingCollectionOutstandingBalance) {
        return  Util.inMoneyFormatWithDollarSign(this.disbursingCollectionOutstandingBalance);
      } else {
        return Util.inMoneyFormatWithDollarSign(0);
      }
    },
    tableColumns() {
      return this.isUsBuyOrder
        ? this.tableColumnsForBuy
        : this.tableColumnsForSell;
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isRelevantDocumentUploaded() {
      const relevantDocuments = [
        Util.TRANSACTION_COMPLETED,
        Util.TRANSACTION_COMPLETION,
      ];
      let isDocumentUploaded =
        this.documents.filter((document) =>
          document.fileTypeNames.some((fileType) =>
            relevantDocuments.includes(fileType)
          )
        ).length > 0
          ? true
          : false;

      return isDocumentUploaded ? true : false;
    },
    isAnyFieldFilled() {
      return Object.values(this.disbursingCollectionInfo).every(
        (field) => field !== null || field !== ""
      );
    },
    outstandingBalanceDate() {
      if (this.disbursingCollections && this.disbursingCollections.length > 0) {
        if (this.isUsBuyOrder) {
          return this.disbursingCollections
            .map((collection) => collection.tracerDate)
            .reduce((first, second) => (first > second ? first : second));
        } else {
          return this.disbursingCollections
            .map((collection) => collection.voucherDate)
            .reduce((first, second) => (first > second ? first : second));
        }
      } else {
        return null;
      }
    },
    isPartial(){
        return this.inspectedReceivedBy.isPartial;
      },
      transactionCompletedDocumentStatus() {
      if (this.uploadedDocumentsStatus && (this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETED") || this.uploadedDocumentsStatus.includes("TRANSACTION COMPLETION"))) {
        return true;
      }
    },
      uploadedDocumentsStatus() {
      if (this.documents && this.documents.length > 0) {
        let uploadedDocuments = [];
        this.documents.forEach((doc) =>
          doc.fileTypeNames.forEach((fileName) =>
            uploadedDocuments.push(fileName)
          )
        );

        return [...new Set(uploadedDocuments)];
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions({
      loadDisbursingCollectionInformation:
        "disbursingCollectionInformation/saveDisbursingCollectionInfoToServer",
      addDisbursementCollection:
        "disbursingCollectionInformation/addDisbursementCollection",
      getDisbursingCollectionInformationStatus:
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
      loadAllDisbursingInfoByOrderId:
        "disbursingCollectionInformation/loadAllDisbursingInfoByOrderId",
      getFundCitations: "fundCitation/getFundCitations",
      getDisbursingCollectionById:
        "disbursingCollectionInformation/getDisbursingCollectionById",
      clearDisbursingCollection:
        "disbursingCollectionInformation/clearDisbursingCollection",
      deleteDisbursingCollection:
        "disbursingCollectionInformation/deleteDisbursingCollection",
      getDisbursingCollectionOutstandingBalance:
        "disbursingCollectionInformation/getDisbursingCollectionOutstandingBalance",
      getAllTooltips: "tooltip/getToolTips",
      getInspectedReceivedBy: "inspectedReceivedBy/getInspectedReceivedBy",
      getDocumentTypes: "documents/getDocumentTypes",


    }),
    loadToolTips(){
    const completionToolTip = this.toolTips.find(e => e.name === "CompletionModule")
    if(completionToolTip && completionToolTip.status){
      this.transaction_completion_tooltip_description = completionToolTip.description ? completionToolTip.description :  null
      this.transaction_completion_tooltip_name = completionToolTip.name ? completionToolTip.name :  null

    }
    return },
    getDocumentType(row){
      if(row.fileId){
      const getDocumnet = this.documents?.filter((e)=> e.id === row.fileId)[0];
      return getDocumnet?.fileTypeNames ? getDocumnet?.fileTypeNames[0] : 'PAYMENT/COLLECTION';
      }else{
        return 'PAYMENT/COLLECTION'
      }
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    async loaded() {
      let orderId = this.getOrderIdFromRoute;
      this.getDisbursingCollectionInformationStatus(orderId);
      this.getDisbursingCollectionOutstandingBalance(orderId);
      this.getFundCitations(orderId);
      this.loadAllDisbursingInfoByOrderId(orderId);
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
    viewTransactionModal(){
      this.showTransactionCompletionModal = !this.showTransactionCompletionModal
    },
    viewItem(disbursingCollectionId, isNew = false , documentType , amount) {
      if(amount){
        this.prevAmount = amount
      }
      if(documentType =="TRANSACTION COMPLETION"){
        this.isTransactionEdit = true
      }else{
        this.isTransactionEdit = false
      }
      let ctx = this;
      if (isNew) {
        ctx.errors.clear();
        ctx.clearDisbursingCollection();
        ctx.showTransactionCompletionModal = true;
        ctx.isNew = isNew;
      } else {

        ctx.getDisbursingCollectionById(disbursingCollectionId).then(() => {
          ctx.errors.clear();
          ctx.disbursingCollectionId = disbursingCollectionId;
          ctx.showTransactionCompletionModal = true;
          ctx.isNew = false;
        });
      }
    },
    // Clearing Modal data after the modal is closed.
    clearModalData() {
      this.getDisbursingCollectionInformationStatus(this.getOrderIdFromRoute);
      this.getDisbursingCollectionOutstandingBalance(this.getOrderIdFromRoute);
      this.errors.clear();
      this.disbursingCollectionId = 0;
      this.showDisbursingCollectionInformationModal = false;
      this.showTransactionCompletionModal = false;
      this.isNew = true;
    },
    formatDate(row, column, cellValue) {
      return Util.convertToDateOnly(cellValue);
    },
    formatCurrency(row, column, cellValue) {
      return Util.inMoneyFormatWithDollarSign(cellValue);
    },
    handleDelete(row, index) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete!`,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let ctx = this;
          ctx.deleteDisbursingCollection(row.id).then(() => {
            ctx.getDisbursingCollectionInformationStatus(ctx.getOrderIdFromRoute);
            ctx.getDisbursingCollectionOutstandingBalance(ctx.getOrderIdFromRoute);
            ctx.loadAllDisbursingInfoByOrderId(ctx.getOrderIdFromRoute);
            this.refreshKey++;
            new swal({
              title: "Confirmation of Delete",
              text: "Payment/Collection has been deleted successfully.",
              icon: "success",
              confirmButtonColor: "#10b45a",
            });
          });
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    fileUploaded(){
       return
      }
  }
};
</script>

<style>
@import "../../../../../../../client-app/public/AGATRS.css";
</style>

<style scoped>
.or-border {
  background-color: #10b45a;
}

.btn-secondary {
  background-color: #d3d7e9;
  border: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary:hover {
  background-color: #cccccc;
  color: #1d253b;
  border-color: #cccccc;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-secondary-dark {
  background-color: #cccccc;
}

.btn-secondary-dark:hover {
  background-color: #d3d7e9;
  border: none;
  color: #1d253b;
}

.edit-cell {
  min-height: 35px;
  cursor: pointer;
}

.el-input__inner {
  border: 1px solid #10b45a;
}

.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}

.btn-primary {
  background-color: #10b45a;
  color: #fff;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:hover {
  border-color: #10b45a;
  color: #fff;
  background-color: #10b45a;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.btn-primary:focus {
  color: #fff;
  outline-color: transparent;
}

.btn-secondary:focus {
  outline-color: transparent;
}

.btn-download {
  background-color: #344675;
  color: #ffffff;
}

.btn-secondary-dark:focus {
  outline-color: transparent;
}
</style>
